/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

function setNewValue ( rawValue ) {
    var value = typeof rawValue === 'string' ? rawValue === 'true' : rawValue;

    //console.log('new playerHardwareAcceleration value: ' + value);

    window.parent.gSTB.SetEnv(JSON.stringify({ // eslint-disable-line
        playerHardwareAcceleration: value
    }));

    window.parent.stbPlayerManager.list[0].hardwareAcceleration = value;

    return value;
}

function getCurrentValue () {
    var value = JSON.parse(window.parent.gSTB.GetEnv(JSON.stringify( // eslint-disable-line
        {varList: ['playerHardwareAcceleration']}
    ))).result.playerHardwareAcceleration;

    value = typeof value === 'string' ? value === 'true' : value;
    //console.log('old playerHardwareAcceleration value: ' + value);

    return value;
}


module.exports = function () {
    return [
        {
            type: 'checkBox',
            items: [
                {className: 'theme-icon theme-icon-hardware-acceleration'},
                {value: gettext('Enable hardware acceleration')},
                {className: 'theme-icon ' + (getCurrentValue() ? 'theme-icon-checkbox-active' : 'theme-icon-checkbox')}
            ],
            description: gettext('Enable or disable player hardware acceleration'),
            setValue: function ( value, $node ) {
                value = setNewValue(value);
                // fix className
                $node.children[0].children[2].className = 'theme-icon ' + (value ? 'theme-icon-checkbox-active' : 'theme-icon-checkbox');
            },
            getValue: function () {
                return getCurrentValue();
            }
        }
    ];
};

module.exports.setValue = function ( value ) {
    setNewValue(value);
};

module.exports.getValue = function () {
    return getCurrentValue();
};
